import { Component, ChangeDetectionStrategy } from '@angular/core';
import { QuestionComponent } from '../abstract/question.component';

@Component({
  selector: 'question-radio',
  templateUrl: './question-radio.component.html',
  styleUrls: ['./question-radio.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionRadioComponent extends QuestionComponent {}
